import { render, staticRenderFns } from "./dialog-registerbusiness.vue?vue&type=template&id=1dbcca8b&"
import script from "./dialog-registerbusiness.vue?vue&type=script&lang=js&"
export * from "./dialog-registerbusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports